import React from 'react';
import EvaluacionProveedor from '../components/Reportes/EvaluacionProveedor';
import MontoContratadoProveedor from '../components/Reportes/MontoContratadoProveedor';
import MontoContratadoCencos from '../components/Reportes/MontoContratadoCenco';
import CumplimientoResponsableCompras from '../components/Reportes/CumplimientoResponsableCompras';
import Radicados from '../components/Reportes/Radicados';
import GestionResponsableCompras from "../components/Reportes/GestionResponsableCompras";
import ReporteTiquetes from '../components/Reportes/ReporteTiquetes';
import ReporteHoteles from '../components/Reportes/ReporteHoteles';
import ReporteDocumentos from '../components/Reportes/ReporteDocumentos';

class ReportesContainer extends React.Component {
    constructor(props) {
        super(props);

        const tabs = [
            { id: 0, caption: "Documentos", component: <ReporteDocumentos /> },
            { id: 1, caption: "Tiquetes", component: <ReporteTiquetes /> },
            { id: 2, caption: "Hoteles", component: <ReporteHoteles /> },
            { id: 3, caption: "Evaluación proveedor", component: <EvaluacionProveedor /> },
            { id: 4, caption: "Monto contratado proveedor", component: <MontoContratadoProveedor /> },
            { id: 5, caption: "Monto contratado cenco", component: <MontoContratadoCencos /> },
            { id: 6, caption: "Cumplimiento responsable compras", component: <CumplimientoResponsableCompras /> },
            { id: 7, caption: "Gestión responsable compras", component: <GestionResponsableCompras /> },
            { id: 8, caption: "Radicados", component: <Radicados /> }
            
        ];

        this.state = {
            tabs,
            selected: 0,
        }
    }

    selectTab(tabId) {
        this.setState({
            selected: tabId
        });
    }

    render() {
        const { tabs, selected } = this.state;
        return (
            <div className="row" style={{ height: '100%', overflowX: 'hidden' }}>
                <div className="col-md-12 col-sm-12 col-xs-12" style={{ height: '100%' }}>
                    <div className="nav-container">
                        <div className="nav-tab-section">
                            <div className="nav-tabs-tabs">
                                {
                                    tabs.map(tab => {
                                        return (
                                            <li key={`li02[${tab.id}]`} className={selected === tab.id ? 'active' : ''}>
                                                <a onClick={(e) => this.selectTab(tab.id)}>{tab.caption}</a>
                                            </li>
                                        )
                                    })
                                }
                            </div>
                        </div>
                        <div className="nav-main-section">
                            <div className="nav-main-section-scrollable">
                                {tabs[selected].component}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ReportesContainer;


// WEBPACK FOOTER //
// ./src/containers/Reportes.jsx